import { ClassValue } from 'clsx';
import { CalendarDay, Modifiers } from 'react-day-picker';

export function formatBlockableDaySquare(
  props: {
    day: CalendarDay;
    modifiers: Modifiers;
  } & React.HTMLAttributes<HTMLDivElement>,
  priorAvailable: boolean,
  classes: ClassValue[],
  includeText: boolean
) {
  if (props.modifiers.available) {
    includeText && classes.push('available');
    if (props.modifiers.checkin) {
      if (!priorAvailable) {
        classes.push('available-pm');
      }
    } else {
      includeText && classes.push('is-disabled');
      if (!priorAvailable) {
        classes.push('available-pm');
      }
    }
  } else {
    includeText && classes.push('unavailable');
    if (priorAvailable) {
      classes.push('available-am');
    } else {
      classes.push('unavailable-blocked');
    }
  }
}
